/** Document shown on first load. */
export const SAMPLE_PATH = "main.ts";

export const SAMPLE_CODE = `interface Peer {
  id: string;
  name: string;
  color: string;
}

function greet(peer: Peer): string {
  return \`Hello, \${peer.name}!\`;
}

const peers: Peer[] = [{ id: "1", name: "Ada", color: "mauve" }];
console.log(peers.map(greet).join("\\n"));
`;
